/**
 * ComplianceSection — Batch #14.326 : prochaines échéances de conformité du dossier (lecture seule) + lien vers le calendrier complet.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock, Loader2 } from "lucide-react";
import { api } from "@/api";
import { STATUS } from "../compliance/ComplianceTable";

export function ComplianceSection({ masterId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    const to = new Date(); to.setDate(to.getDate() + 120);
    const from = new Date(); from.setDate(from.getDate() - 60);
    api.get(`/admin/compliance/${masterId}`, { params: { from: from.toISOString().slice(0, 10), to: to.toISOString().slice(0, 10) } }).then((r) => setData(r.data)).catch(() => setData({ rows: [], counts: {} }));
  }, [masterId]);
  const rows = (data?.rows || []).filter((r) => r.status !== "done").slice(0, 6);
  return (
    <div className="border border-slate-200 rounded-xl p-4" data-testid="masters-compliance-section">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-semibold text-slate-800 inline-flex items-center gap-2"><CalendarClock className="w-5 h-5 text-amber-600" /> Conformité — prochaines échéances</h2>
        <Link to={`/admin/conformite?master=${masterId}`} className="text-xs text-indigo-700 hover:underline" data-testid="masters-compliance-link">Calendrier complet →</Link>
      </div>
      {!data ? <Loader2 className="w-4 h-4 animate-spin text-slate-400" /> : !rows.length ? (
        <div className="text-sm text-slate-400 italic" data-testid="masters-compliance-empty">Aucune échéance dans les 120 prochains jours.</div>
      ) : (
        <ul className="divide-y text-sm" data-testid="masters-compliance-list">
          {rows.map((r) => (
            <li key={r.key} className="py-1.5 flex items-center gap-3" data-testid={`masters-compliance-row-${r.key}`}>
              <span className="font-mono text-xs text-slate-600 w-24">{r.due}</span>
              <span className="flex-1 text-slate-800">{r.label}</span>
              <span className={`text-[11px] font-semibold px-2 py-0.5 rounded-full border ${STATUS[r.status].cls}`}>{STATUS[r.status].label}</span>
            </li>
          ))}
        </ul>
      )}
      {data?.counts && <div className="text-[11px] text-slate-500 mt-2">{data.counts.overdue || 0} en retard · {data.counts.soon || 0} dans 7 jours · {data.counts.upcoming || 0} à venir</div>}
    </div>
  );
}
